import logoWhite from 'src/theme/brand/mattech-horizontal-white.png'

import classes from './app-brand-mark.module.css'

type AppBrandMarkProps = {
    size?: 'sm' | 'md'
}

export function AppBrandMark({size = 'md'}: AppBrandMarkProps) {
    return (
        <div
            className={classes.root}
            data-size={size}
            aria-label="Depot for Mat Tech"
            data-testid="app-brand-mark"
        >
            <img className={classes.logo} src={logoWhite} alt="Mat Tech" />
            <span className={classes.product}>Depot</span>
        </div>
    )
}
